<air-table
  [columns]="columns"
  [dataSource]="_dataSource"
  [searchable]="searchable"
  (clickRow)="rowClicked.emit($event)"
  class="cosmos-custom-table__table"
  sortable
  selectable
>
  <ng-content air-table-header-slot-right></ng-content>
</air-table>
<div class="w-100">
  <div class="d-flex justify-content-center mt-1">
    <cosmos-stack-paginator></cosmos-stack-paginator>
  </div>
</div>
